import React, { Component } from "react";
import VehicleReportTablePivot from "./VehicleReportTablePivot";
import styles from "./vehicleReportTable.module.scss";
import TooltipWrapper from "../../shared/items/contols/tooltipWrapper";
import { v4 as uuidv4 } from "uuid";

const rowStyles = [styles.reportTableRow, styles.reportTableRowBackground];

class VehicleReportTableDayContent extends Component {
  getSelectDateRow({ selectDate, day }) {
    if (selectDate === null) return null;

    let selectDateRow = null;
    const date = new Date(selectDate);

    if (date.getMonth() !== new Date(day.rows[0].time).getMonth() || date.getDate() !== new Date(day.rows[0].time).getDate()) {
      return null;
    }

    for (let i = 0; i < day.rows.length - 1; i++) {
      if (new Date(day.rows[i].time) <= date && date < new Date(day.rows[i + 1].time)) {
        selectDateRow = day.rows[i].time;
      }
    }

    if (!selectDateRow) {
      selectDateRow = day.rows[day.rows.length - 1].time;
    }

    return selectDateRow;
  }

  getDashboard(dashboards) {
    const { isDahsbordVisible } = this.props;

    if (!isDahsbordVisible) {
      return null;
    }

    return (
      <div className={styles.reportTableDashboardContainer}>
        {dashboards.map((dashboard) => {
          return this.getDashboardRow(dashboard);
        })}
      </div>
    );
  }

  getDashboardRow(dashboard) {
    return (
      <div className={styles.reportTableDashboardRow}>
        {dashboard.map((item) => {
          if (item === null) {
            return <div className={styles.reportTableDashboardItemEmpty} key={uuidv4()}></div>;
          }

          return (
            <div className={styles.reportTableDashboardItem} key={uuidv4()}>
              <b>{item.title}: </b>
              <span>{item.value}</span>
              <span>{item.measure}</span>
            </div>
          );
        })}
      </div>
    );
  }

  getRowCell(item) {
    return (
      <div key={uuidv4()} className={styles.reportTableRowItem} style={{ width: item.width + "px", border: "none" }}>
        <span style={{ border: "none" }}>{item.value}</span>
      </div>
    );
  }

  getRows(day, selectDate) {
    let rowStyle = rowStyles[1];

    return day.rows.map((row) => {
      rowStyle = rowStyle === rowStyles[0] ? rowStyles[1] : rowStyles[0];

      rowStyle = selectDate !== row.time ? rowStyle : styles.reportTableSelectRow;

      const onClick = () => {
        this.props.handlerRowClick(row.time);
        this.props.handleClickRow(row.time);
      };

      const onDoubleClick = () => {
        this.props.handlerRowClick(row.time);
        this.props.handleClickRow(row.time, true);
      };

      return (
        <div className={styles.reportTableRowCursor} key={uuidv4()}>
          <div onClick={onClick}>
            <div className={rowStyle} onDoubleClick={onDoubleClick}>
              {row.data.map((item) => {
                return this.getRowCell(item);
              })}
            </div>
          </div>
        </div>
      );
    });
  }

  handleDashboardClick() {
    const { isDahsbordVisible } = this.props;

    if (isDahsbordVisible) {
      this.props.onCloseDashboard(this.props.day.day);
    } else {
      this.props.onOpenDashboard(this.props.day.day);
    }
  }

  render() {
    const { day, isDahsbordVisible } = this.props;

    return (
      <div key={uuidv4()} className={styles.reportTableDayContent}>
        <div className={styles.reportTableDashboardControl} onClick={this.handleDashboardClick.bind(this)}>
          <TooltipWrapper title={`Дополнительная информация о маршруте за ${day.day}`} position="top">
            <b>Подробнее {isDahsbordVisible ? <b>-</b> : <b>+</b>}</b>
          </TooltipWrapper>
        </div>
        {this.getDashboard(day.dashboard)}
        {this.getRows(day, this.getSelectDateRow(this.props))}
        <VehicleReportTablePivot pivot={day.pivot} />
      </div>
    );
  }
}

export default VehicleReportTableDayContent;
